import request from '../utils/http'
import storage from '../utils/storage'
const appid = storage.get('USERINFO') ? storage.get('USERINFO').appid : 0 // 不同小程序对接同一后台
// appid：0-维应SPR开发版 | 2000-维应SPR

// 修改用户信息 205
export function updateUserInfo(data) {
    return request({
        url: "/service/h5.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_shop_user_edit",
            ...data 
        }  //接口参数
    })
}

// 修改用户 姓名/手机号 325
export function updateUserNameTel(data) {
    return request({
        url: "/service/shop.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "upuser2",
            ...data 
        }  //接口参数
    })
}

// 修改用户扩展信息 143
export function updateUserExtInfo(data) {
    return request({
        url: "/service/farming.ashx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            Method: "ams_farming_user_ext_edit",
            ...data 
        }  //接口参数
    })
}


// 修改用户昵称头像 3
export function updateUserNickTx(data) {
    return request({
        url: "/service_app/saveuser.aspx",  //接口路径
        method: "get",  //接口方法
        // headers: { 'Content-Type': 'multipart/form-data' }, //给接口添加请求头
        params: {
            appid,
            ...data
        }  //接口参数
    })
}
